import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogPosts } from '../data/blog-posts';

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="text-center py-24 sm:py-32">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Post not found</h1>
        <p className="mt-4 text-lg leading-8 text-gray-600">
          Sorry, we couldn’t find the post you’re looking for.
        </p>
        <div className="mt-10">
          <Link to="/blog" className="text-sm font-semibold leading-7 text-indigo-600">
            <span aria-hidden="true">&larr;</span> Back to blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-slate-50">
      <header
        className="relative bg-cover bg-center py-32 sm:py-48"
        style={{ backgroundImage: `url(${post.imageUrl})` }}
      >
        <div className="absolute inset-0 bg-slate-900 bg-opacity-60" />
        <div className="relative mx-auto max-w-4xl px-6 text-center text-white">
          <div className="flex justify-center flex-wrap items-center gap-4 mb-4">
            <span className="relative z-10 rounded-full bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-600">
              {post.type}
            </span>
            {post.category.split(',').map((cat) => (
              <span key={cat} className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                {cat.trim()}
              </span>
            ))}
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-6xl" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.6)' }}>{post.title}</h1>
          <div className="mt-6 flex justify-center items-center gap-x-4 text-lg text-gray-200">
            <time dateTime={post.date}>
              {new Date(post.date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </time>
          </div>
        </div>
      </header>

      <main className="relative z-10 -mt-24 pb-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <article className="bg-white rounded-2xl shadow-2xl p-6 sm:p-10">
            <div
              className="prose prose-lg prose-indigo max-w-none"
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
            
            <div className="mt-12 border-t border-gray-200 pt-8 text-center">
              <Link
                to="/blog"
                className="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                <span aria-hidden="true">&larr;</span>
                Back to all articles
              </Link>
            </div>
          </article>
        </div>
      </main>
    </div>
  );
};

export default BlogPostPage; 